<template>
    <div class="p-3 row">
        <input-text class="col-12 col-md-4" label="Versão" :disabled="readonly" v-model="form.versao" ref="versao" required/>
        <input-select class="col-12 col-md-4" :disabled="readonly" :min="1" :options="duracoes.filter(el => { return (projeto.anoInicio < 2016 ? (el.value < 24) : (el.value == 24)) })" label="Nova duração" v-model="form.duracao" ref="novaDuracao" required/>
        
        <div class="col-12" v-if="!readonly">
            <b-button variant="success" v-if="permissao.c" @click="$emit('salvar',form)">
                <i class="fa-solid fa-file-code mr-2"></i>
                Gerar XML
            </b-button>
        </div>
        <div class="col-12 mt-3">
            <h6>Lista de XML's Gerados</h6>
            <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="$emit('download', data.item)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import InputText from '@/components/inputs/InputText';
import InputSelect from '@/components/inputs/InputSelect';

import helpers from '@/common/utils/helpers';
import {FormMixin} from '@/common/mixins/FormMixin';
export default {
    name: 'Aneel6',
    mixins: [FormMixin],
    props: {
        itens : {
            default: () => []
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        },
        projeto : {
            required: true,
        }
    },
    components: {
        InputText,
        InputSelect
    },   
    data: () => ({
        
        duracoes : [
            {value: 6, text: '6 meses'},
            {value: 12, text: '12 meses'},
            {value: 24, text: '24 meses'},
        ],
        form : {
            codigoInterno: null,
            versao: 0,
            duracao: null
        },
        table : {
            fields : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão"},
                { key: "dataCriacao", label:"Data de envio",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "actions", label:"Ações"},
            ]
        }
    })  , 
    watch: {
        itens: {
            handler: function(newValue) {
                this.form.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        }
    },
    computed :{
        readonly :function(){
            return this.$route.name != 'projeto-gestao-proponente-detalhamento' || !this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoObrigacoesAneel');
        },
    }
}
</script>
<style lang="">
    
</style>